// src/ScrollManager.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollManager() {
  const { pathname, hash, key } = useLocation();

  // вимикаємо авто-відновлення позиції історією браузера
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      const prev = window.history.scrollRestoration;
      window.history.scrollRestoration = "manual";
      return () => { window.history.scrollRestoration = prev; };
    }
  }, []);

  // скролимо вгору при кожній зміні маршруту (крім хеш-якоря)
  useEffect(() => {
    if (hash) return; // якщо переходиш на #якір — не заважаємо
    // даємо React домалювати розмітку, тоді скролимо
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });
  }, [pathname, key, hash]); // key зміниться і при push/replace

  return null;
}
